import React from 'react';
import PropTypes from 'prop-types';
import {
  Grid, Label, Accordion, Icon,
} from 'semantic-ui-react';
import { GREEN_AUTO_IMS_STATUS } from '../../constants';

const ResaleInformation = ({
  vehicleRecord,
  formatField,
  formatDate,
  activeIndex,
  handleClick,
}) => {
  const autoImsStatus = GREEN_AUTO_IMS_STATUS.includes(
    vehicleRecord.returnVehAutoIMSStatus
  )
    ? 'green-font'
    : 'black-font';

  return (
    <div className='accordion-div'>
      <Accordion.Title
        active={activeIndex.includes(4)}
        index={4}
        onClick={handleClick}
        className='accordion-title'
      >
        Resale Information
        <Icon name='dropdown' className='right-icon' />
      </Accordion.Title>
      <Accordion.Content
        active={activeIndex.includes(4)}
        className='accordion-content'
      >
        <Grid columns={3} divided className='vst-grid'>
          <Grid.Row>
            <Grid.Column mobile={16} tablet={5} computer={5}>
              <strong>AutoIMS Vehicle Status</strong>
              <Label basic className={autoImsStatus}>
                {formatField('returnVehAutoIMSStatus')}
              </Label>
            </Grid.Column>
            <Grid.Column mobile={16} tablet={5} computer={5}>
              <strong>Resold Seller Number/Name</strong>
              <Label basic />
            </Grid.Column>
            <Grid.Column mobile={16} tablet={5} computer={5}>
              <strong>Resold Date</strong>
              <Label basic />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column mobile={16} tablet={5} computer={5}>
              <strong>Left Lot Date</strong>
              <Label basic>{formatDate('consignmentsCheckedOutDate')}</Label>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Accordion.Content>
    </div>
  );
};

ResaleInformation.propTypes = {
  vehicleRecord: PropTypes.object.isRequired,
  formatField: PropTypes.func.isRequired,
  formatDate: PropTypes.func.isRequired,
  activeIndex: PropTypes.array.isRequired,
  handleClick: PropTypes.func.isRequired,
};

export default ResaleInformation;
